// @flow
import * as React from "react";
import "./base-popup.scss";
import "react-toastify/dist/ReactToastify.min.css";
export const BasePopup = ({
  store,
  closeOnClickingOutside,
  className,
  popupName,
  children,
}) => (
  <>
    <div
      className="overlay"
      onClick={() => {
        if (closeOnClickingOutside) store.togglePopup(popupName, false);
      }}
    />
    <div className={`popup ${className}`}>{children}</div>
  </>
);
